import React from "react";
import Button from "./Button";
import styles from "./CTA.module.css";

interface CTAProps {
  onClick: () => void;
}

const CTA: React.FC<CTAProps> = ({ onClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick();
  };

  return (
    <div className={styles.cta}>
      <p className={styles.ctaText}>Ready to build something exceptional?</p>
      <Button href="#contact" onClick={handleClick} size="medium">
        Get in touch
      </Button>
    </div>
  );
};

CTA.displayName = "CTA";

export default CTA;
